import { EventEmitter, Injectable, Output } from '@angular/core';
import { RequestService } from '@commonServices/request.service';
import { Client as CatalogAPI } from "@interfaces/HttpClient/CatalogApiModels";
import { firstValueFrom, of } from 'rxjs';

@Injectable()
export class CatalogRootNodeProtocolService {
	@Output() rootNodeChanged = new EventEmitter();
	public rootNodeIdWithProtocol;

	constructor(
		private catalogApi: CatalogAPI,
		private requestService: RequestService
	) { }

	private static currentRootNode: { key: string; value: number };

	async getPreviewCatalogRootNode(catalogKey: string): Promise<number> {
		try {
			if (CatalogRootNodeProtocolService.currentRootNode?.key === catalogKey) {
				return firstValueFrom(of(CatalogRootNodeProtocolService.currentRootNode?.value))
			}
			const result = (await firstValueFrom(this.catalogApi.previewCatalogView_GetPreviewCatalogRootNode(catalogKey))).id;
			CatalogRootNodeProtocolService.currentRootNode = {
				key: catalogKey, value: result
			};
			return result;
		} catch (e) {
			return this.requestService.errorHandling(e, null, [
				{ status: 204, return: undefined }
			]);
		}
	}
}
